module.exports = __webpack_public_path__ + "static/media/thehomealbum-IG.f4b623e6.PNG";